import { useCallback, useMemo, useState } from 'react'

import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { usePage } from '@/components/providers/PageProvider'
import { useFetchStatic } from '@/hooks/useFetchStatic'
import { getRankOverTimeHelpers, getRankOverTimePoints } from '@/utils/chartUtil'
import { createDynamicComponent } from '@/utils/factoryUtil'

import styles from './ChartsRankOverTime.module.scss'

const ChartsRankOverTimeGraphMain = createDynamicComponent({
  loader: () => import('./ChartsRankOverTimeGraphMain/ChartsRankOverTimeGraphMain'),
  name: 'ChartsRankOverTimeGraphMain',
})

const ChartsRankOverTimeGraphBrush = createDynamicComponent({
  loader: () => import('./ChartsRankOverTimeGraphBrush/ChartsRankOverTimeGraphBrush'),
  name: 'ChartsRankOverTimeGraphBrush',
})

export const ChartsRankOverTime = () => {
  const { page } = usePage()
  const { loading: loadingPage } = useBreakpoints()
  const rankOverTime = page?.charts?.rankOverTime
  const [indexStart, setIndexStart] = useState(0)
  const [indexEnd, setIndexEnd] = useState(Object.keys(rankOverTime || {}).length)
  const { data: setsRecent, isLoading: loadingFetch } = useFetchStatic('setsRecent')

  const loading = loadingPage || loadingFetch

  const points = useMemo(() => getRankOverTimePoints({ rankOverTime }), [rankOverTime])

  const rankOverTimeHelpers = useMemo(
    () => getRankOverTimeHelpers({ indexEnd, indexStart, points, setsRecent }),
    [indexEnd, indexStart, setsRecent, points],
  )

  const onBrushChange = useCallback(({ endIndex, startIndex }: { endIndex: number; startIndex: number }) => {
    setIndexStart(startIndex)
    setIndexEnd(endIndex)
  }, [])

  if (points.length < 1) return null

  return (
    <div className={styles.container}>
      <p className={styles.yAxisLabel}>Rank</p>
      <div className={styles.chartMain}>
        {!loading && <ChartsRankOverTimeGraphMain points={points} rankOverTimeHelpers={rankOverTimeHelpers} />}
      </div>
      <p className={styles.xAxisLabel}>Month</p>
      <div className={styles.chartBrush}>
        {!loading && points.length >= 6 && (
          <ChartsRankOverTimeGraphBrush onBrushChange={onBrushChange} points={points} />
        )}
      </div>
    </div>
  )
}
